import { AbstractControl, ValidationErrors } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

const errors = {
  required: 'Este campo es obligatorio',
  requiredTrue: 'Debe aceptar este campo para proseguir',
  badCharacters: 'Este campo contiene carácteres inválidos',
  cuitAlreadyTaken: 'Ya existe una cuenta con este cuit',
  badCUIT: 'El CUIT/CUIL que ingresó es inválido',
  badDNI: 'El DNI que ingresó es inválido',
  badRUT: 'El RUT que ingresó es inválido',
  badRUTLength: 'El RUT debe ser de al menos 8 caracteres',
  minlength: 'Este campo debe contener al menos 8 caracteres',
  minlengthChl: 'Este campo debe contener al menos 3 caracteres',
  notRepeated: 'Las contraseñas no coinciden',
  pattern:
    'La contraseña debe tener al menos: un número, una mayúscula, una minúscula y un caracter especial (#$^+=-_!*()@%&.,?"\')',
  invalidCredentials: 'Las credenciales son incorrectas',
  emailAlreadyTaken: 'Ya existe una cuenta con este email',
  dniAlreadyTaken: 'Ya existe una cuenta con ese dni',
  emailDoesntExist: 'No existe una cuenta con ese email asociado.',
  email: 'Ingrese un email válido',
  max: 'Numero de dni inválido',
  maxlength: 'El campo es muy largo',
  passwordnomatch: 'Las contraseñas no coinciden',
  passwordMatch: 'La nueva contraseña debe ser diferente a la anterior',
  requiredshort: 'Requerido',
  minlengthsix: 'Debe contener al menos 6 caracteres',
  minlengtheight: 'Deve conter 8 caracteres',
  minlengthfive: 'Debe contener 5 caracteres',
  minlengthfour: 'Debe contener al menos 4 caracteres',
  minlengththree: 'Debe contener al menos 3 caracteres',
  minlengthseven: 'Debe contener al menos 7 caracteres',
  usernotexists: 'Este usuario no forma parte de la plataforma',
  useralreadyexclusive: 'Este usuario ya disfruta este beneficio',
  phoneShort: 'Mínimo de 10 dígitos',
  invalidUIF: 'Declaración UIF inválida',
  blocked: 'Su usuario fue bloqueado. Intente en 5 minutos',
  cuilMin: 'El CUIT o CUIL debe tener 11 dígitos',
  ccMin: 'La Cédula de ciudadanía o extranjería debe tener al menos 6 dígitos',
  cpfMin: 'O cadastro de pessoas físicas deve ter 11 dígitos',
  cuiMin: 'El CUI debe tener 13 dígitos',
  rucMin: 'El RUC debe tener un mínimo de 8 dígitos',
  notNumber: 'Este campo solo permite números',
  bad2faCode: 'El código ingresado es incorrecto, intentá nuevamente',
  invalidCbu: 'El CBU es inválido o no corresponde con tu CUIT/CUIL',
  accountAdded: 'Ya agregaste esta cuenta',
  cuitUnmatch: 'Esta cuenta no se encuentra asociada con su cuit',
  coinUnmatch: 'La cuenta ingresada no pertenece a la divisa solicitada',
  minlengthAddress: 'Este campo debe contener al menos 26 caracteres',
  invalidAddress: 'Dirección inválida',
  minSalary: 'El salario debe ser mayor a 0',
  employeeExist: 'Ya existe un empleado con este CUIT',
  cuitSameAsOwn: 'No se permite agregar su propio CUIT',
  invalidColor:
    'El color elegido podría ocasionar problemas al momento de escanear el QR. Elija un color más oscuro.',
  bannedCbu: 'El CBU es inválido, por favor intente con otro',
  invalidWalletAddress: 'Wallet inválida',
  invalidEmail: 'El email que ingresaste no es válido',
  invalidColombianPhone: 'Ingrese un número telefónico válido',
  mask: 'La cantidad de caracteres es incorrecta.',
} as ValidationErrors;

export default errors;

export class formErrorHelper {
  constructor(private translate?: TranslateService) {}
  getErrorMessage(
    control?: AbstractControl | null,
    miniapp: boolean = false,
    ...params: string[]
  ): string {
    const controlErrors = control?.errors;
    if (!controlErrors) {
      return '';
    }
    const keys = Object.keys(controlErrors);
    if (keys.length === 0) {
      return '';
    }

    const errorKey = keys[0] as keyof typeof errors;
    let errorMessage = '';
    if (this.translate) {
      const key = miniapp ? `AMOUNT_SELECTION.ERRORS.${errorKey}` : `ERROR_CODES.${errorKey}`;
      this.translate.get(`${key}`).subscribe((translatedMessage) => {
        errorMessage = translatedMessage;
      });
    } else {
      errorMessage = errors[errorKey];
    }

    return errorMessage.replace(/\{\d+\}/g, (match: string) => {
      const index = parseInt(match.replace(/\D/g, ''), 10);
      return params[index];
    });
  }

  getInputErrorMessage(control?: AbstractControl | null, ...params: string[]): string {
    const controlErrors = control?.errors;
    if (!controlErrors) {
      return '';
    }
    const keys = Object.keys(controlErrors);
    if (keys.length === 0) {
      return '';
    }

    const errorKey = keys[0] as keyof typeof errors;

    let errorMessage = '';
    this.translate.get(`ERROR_CODES.${errorKey}`).subscribe((translatedMessage) => {
      errorMessage = translatedMessage;
    });

    return errorMessage.replace(/\{\d+\}/g, (match: string) => {
      const index = parseInt(match.replace(/\D/g, ''), 10);
      return params[index];
    });
  }

  formControlHasError(formControl: AbstractControl | null): boolean {
    if (!formControl) {
      return false;
    }
    return formControl.invalid && (!formControl.pristine || formControl.touched);
  }
}
